module.exports = __webpack_public_path__ + "img/mobile_banner.c6304087.png";